import React from 'react';

import styled, { css } from 'styled-components';

import { Heading } from '~/techstyle-shared/react-components';

const defaultTypeScale = [48, 42, 36, 30, 24, 18];

const getFontSize = (props) => {
  const typeScale =
    (props.theme.heading && props.theme.heading.typeScale) || defaultTypeScale;
  const value = typeScale[props.level - 1] || defaultTypeScale[props.level - 1];
  return typeof value === 'number' ? `${value}px` : value;
};

const propStyles = css`
  margin: 0;
  font-size: ${getFontSize};
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  line-height: 1.5;
  text-transform: ${(props) => (props.uppercase ? 'uppercase' : 'initial')};
  text-align: ${(props) => props.align};
  color: ${(props) =>
    props.white
      ? props.theme.colors.palette.white
      : props.theme.colors.palette.black};
  ${(props) => (props.theme.heading ? props.theme.heading.defaultStyle : '')};
`;

const StyledHeading = (props) => <Heading {...props} />;

export const Header = styled(StyledHeading)`
  ${propStyles};
`;

Header.defaultProps = {
  align: 'inherit',
  level: 1,
};
